<template>
  <div class="solution page-wrapper">
    <el-image
      class="banner"
      style="width: 100%;"
      :src="require('../../assets/sl_banner4.png')"
      fit="scale-down">
    </el-image>
    <div class="container">
      <div class="row">
        <el-row class="section1" :gutter="40">
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/sl_image4.png" alt="">
          </el-col>
          <el-col :span="12" :xs="{span: 24}">
            大于家电智能化方案, 涵盖冰箱、空调、洗衣机、热水器、风扇、温奶器等多种家庭主要电器, 提供数十种产品智能化解决方案, 赋能开发者快速对接全套生活家电智能产品。方案兼容Wi-Fi+BLE、Wi-Fi、BLE、NB-IoT、GPRS等多种协议，持各家生活家电品牌、设备间的互通互联
          </el-col>
        </el-row>
        <hr class="section2"/>
        <h2 class="section3">智能照明</h2>
        <div class="section4">
          <!-- <img :src="`../../assets/icon-left.png`" alt=""> -->
          <el-row :gutter="0">
            <el-col :span="8" :xs="{span: 24}" class="link" @click.native="$router.push('/solution/bulb')">
              <img src="../../assets/sl_slider10.png" alt="">
              <span>球泡灯智能化方案</span>
            </el-col>
            <el-col :span="8" :xs="{span: 24}" class="link" @click.native="$router.push('/solution/led')">
              <img src="../../assets/sl_slider11.png" alt="">
              <span>吸顶灯智能化方案</span>
            </el-col>
            <el-col :span="8" :xs="{span: 24}" class="link" @click.native="$router.push('/solution/dengdai')">
              <img src="../../assets/sl_slider12.png" alt="">
              <span>灯带智能化方案</span>
            </el-col>
          </el-row>
          <!-- <img :src="`../../assets/icon-right.png`" alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.section1 {
  margin: 40px 0;
  position: relative;
  .el-col {
    height: 100%;
    position: relative;
    img {
      width: 100%;
    }
  }
  .el-col:last-child {
    height: 350px;
    display: flex;
    align-items: center;
    line-height: 1.66;
  }
}
.section2 {
  border-left: 0;
  border-right: 0;
  border-top: 0;
  border-bottom: 1px solid #DDD;
}
.section3 {
  text-align: center;
  margin: 100px 0 40px;
}
.section4 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 160px;
  & > img {
    flex: 0 0 auto;
  }
  .el-row {
    flex: 1 1 auto;
    .el-col {
      position: relative;
      text-align: center;

      & span {
        position: absolute;
        bottom: 100px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>